/* eslint-disable react/prop-types */
import { Typography } from '@mui/material';
import { configuration } from 'utils/environment/configuration';

export const logger = {
    log: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.log(...args);
        }
    },
    error: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.error(...args);
        }
    },
    warn: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.warn(...args);
        }
    },
    info: (...args) => {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.info(...args);
        }
    }
};

export const DebugPanel = ({ data }) => {
    if (configuration.isProduction === 'production') return null;

    return (
        <div style={{ padding: '20px' }}>
            <Typography variant="caption">Debug Data:</Typography>
            <pre
                style={{
                    maxHeight: '200px',
                    overflow: 'auto',
                    fontSize: '12px',
                    background: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px'
                }}
            >
                {JSON.stringify(data, null, 2)}
            </pre>
        </div>
    );
};
